import Vue from 'vue'
import VueI18n from 'vue-i18n'
import EN from 'element-ui/lib/locale/lang/en'
import Zh_CN from 'element-ui/lib/locale/lang/zh-CN'
import ENLocale from './en-US'
import ZH_CNLocale from './zh-CN'
import { getBrowserLang } from '@/utils'
Vue.use(VueI18n)
const messages = {
  'zh-CN': {
    ...ZH_CNLocale,
    ...Zh_CN
  },
  'en-US': {
    ...ENLocale,
    ...EN
  }
}
export const getLocaleLang = () => {
  let lang = 'en-US'
  if (!localStorage.getItem('Language')) {
    lang = getBrowserLang()
    localStorage.setItem('Language', lang)
  } else {
    lang = localStorage.getItem('Language') || 'en-US'
  }
  return lang
}
const i18n = new VueI18n({
  locale: getLocaleLang(),
  messages, // 设置全局当地语言包,
  fallbackLocale: 'en-US',
  globalInjection: true,
  silentTranslationWarn: true // 关闭警告信息
})

export default i18n
